import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { CategoryWriteRequest } from '@/api/handlers/resources/categories/requests';
import type { CategoryWriteResponse } from '@/api/handlers/resources/categories/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { CategoryQueryKeys } from './categoryQueryKeys';

export type UpdateCategoryVariables = {
    id: string;
    body: CategoryWriteRequest;
};

export const useUpdateCategoryMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<
        ApiResponse<CategoryWriteResponse>,
        Error,
        UpdateCategoryVariables
    >({
        mutationFn: ({ id, body }) =>
            apiClient.categories.updateCategory(id, body),
        onSuccess: (result) => {
            if (result.success) {
                queryClient.invalidateQueries({
                    queryKey: CategoryQueryKeys.all,
                });
            }
        },
    });
};
